export const BONUS_EVENT_DATA = [
  {
    title: '기부 캠페인 참여 사실을 인증하면 \nMacbook Pro 14를 드려요!',
    info: [
      '1. 기부 참여 후 SNS(인스타, 블로그 등 종류 무관)에 기부인증서 업로드',
      '2. [참여 인증하기] 버튼을 눌러 업로드 링크 제출',
      '3. 추첨을 통해 총 한 분께 맥북 프로 14를 드려요.',
    ],
    description:
      '* 자세한 참여 방식은 [참여 인증하기] 버튼을 눌러 확인해주세요.',
  },
];
